var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.33,
    height: 21.33,
    viewBox: "0 0 21.33 21.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1803.67 -989)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1795 980.33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,8.67H10.67a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10.67A2,2,0,0,0,28,8.67ZM24.67,20.33H20.33a19.6,19.6,0,0,0-2,0H14a1,1,0,0,1-.9-1.43l.47-.47c.134-.065,4.611-.1,4.76-.1h0c.01,0,2,.013,2,0h4.34a1,1,0,0,1,0,2Z",
    fill: "#1f2e3d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.ab5f3442b0fc5e3ff257285de3b08bc8.svg";
export { ForwardRef as ReactComponent };